import CheckboxGroupBuilder from './CheckboxGroupBuilder';
import CheckboxFilterBuilder from './CheckboxFilterBuilder';
import CharacterCodes from '../../constants/Characters/CharacterCodes';
import Template from '../../classes/Template';
import ViewPanels from '../../constants/ViewPanels';

export default class MobileCheckBoxGroup extends CheckboxGroupBuilder {
  /**
   * @inheritDoc
   */
  build(): HTMLElement {
    const group = this.group.getElementByRef('filter-group');
    const groupName = this.group.getElementByRef('filter-group-name');
    const activeFiltersWrapper = this.group.getElementByRef('filter-group-active-filters');
    const subPanel = this.group.getElementByRef('sub-panel');
    const mainPanel = this.group.getElementByRef('main-panel');
    const header = this.group.getElementByRef('header');
    const footer = this.group.getElementByRef('footer');
    const headerTemplate = Template.getContent(header);
    const footerTemplate = Template.getContent(footer);
    const panelHeaderPrevious = headerTemplate.getElementByRef('panel-header-previous');
    const panelHeaderTitle = headerTemplate.getElementByRef('panel-header-title');
    const subPanelFilterButton = footerTemplate.getElementByRef('sub-panel-filter-button');
    const filterWrapper = this.group.getElementByRef('checkbox-filter');

    group.setAttribute('data-id', `mobile-filter-${this.data.id}`);

    groupName.innerHTML = this.data.name;
    groupName.setAttribute('data-id', `mobile-filter-${this.data.id}`);

    if (this.data.isActive) {
      groupName.classList.add('font-bold');
    }

    const activeFilters: Array<Object> = this.data.filters.filter((filter: Object) => filter.isActive);

    if (activeFilters.length) {
      activeFiltersWrapper.classList.add('mt-2');
    }

    activeFilters.forEach((filter: Object, index: number) => {
      const activeFilterElement = document.createElement('li');
      activeFilterElement.innerText = filter.name;

      if (index < activeFilters.length - 1) {
        activeFilterElement.innerText += ',' + String.fromCharCode(CharacterCodes.NON_BREAKING_SPACE);
      }

      if (window.store.activeViewPanels.contains(`mobile-filter-${this.data.id}`)) {
        subPanel.classList.add(ViewPanels.ACTIVE_CLASS);
      }

      activeFiltersWrapper.appendChild(activeFilterElement);
    });

    subPanel.setAttribute('data-id', `mobile-filter-${this.data.id}`);
    panelHeaderPrevious.setAttribute('data-id', `mobile-filter-${this.data.id}`);
    panelHeaderTitle.innerHTML = this.data.name;

    const newHeader = document.createElement('template');
    newHeader.setAttribute('ref', 'header');
    newHeader.content.appendChild(headerTemplate);
    header.remove();
    mainPanel.insertBefore(newHeader, mainPanel.firstChild);

    const newFooter = document.createElement('template');
    newFooter.setAttribute('ref', 'footer');
    newFooter.content.appendChild(footerTemplate);
    footer.remove();
    mainPanel.appendChild(newFooter);

    subPanelFilterButton.setAttribute('data-id', `mobile-filter-${this.data.id}`);

    if (window.store.activeViewPanels.contains(`mobile-filter-${this.data.id}`)) {
      subPanel.classList.add(ViewPanels.ACTIVE_CLASS);
      subPanel.classList.remove('hidden');
    }

    this.data.filters.forEach((filter: Object) => {
      const template = filterWrapper.cloneNode(true);
      const checkbox = new CheckboxFilterBuilder(template, filter, this.data).build();
      filterWrapper.parentNode.appendChild(checkbox);
    });
    filterWrapper.remove();

    return this.group;
  }
}
